module.exports = __webpack_public_path__ + "static/media/about.1b5dee4.mp4";


//////////////////
// WEBPACK FOOTER
// ./assets/video/about.mp4
// module id = dUb8
// module chunks = 1